import React, { Component } from 'react';
import { Upload, Icon, Modal, message } from 'antd';
import {gcsKeys,config,CLOUD_FUNCTION} from '../../../../../../config/fbConfig'


class Avatar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      previewVisible: false,
      previewImage: '',
      fileList: [],
      isImage: true
    };
  }

  componentWillMount() {
    this.setState({fileList:this.props.imageFileList})
  }
  
  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = async file => {
    this.setState({
      previewImage: file.url || file.preview || file.thumbUrl,
      previewVisible: true,
    });
  }

  handleChange = ({ fileList,file }) => {
    const { status } = file;
    if (status === 'done') {
    var {mediaLink} = file.response;
    fileList[0].thumbUrl = mediaLink
     this.setState({ fileList },()=>{
      this.props.handleImageChange(fileList)
     });

    }
    else this.setState({ fileList });
  }
  data = (file)=>{
    return {
      projectId: config.projectId,
      destination: `images/${this.props.profile.uid}/${file.name}`
   }
  }
  render() {
    const { previewVisible, previewImage, fileList } = this.state;
    // const { getFieldDecorator, normFile } = this.props;
    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">Upload</div>
      </div>
    );
    return (
      <div className="clearfix">
         <Upload
          action='https://orsityfileserver.herokuapp.com/fileupload'         
          data={this.data}
          accept="image/*"
          listType="picture-card"
          fileList={fileList}
          onPreview={this.handlePreview}
          onChange={this.handleChange}
        >
          {fileList.length ===1 ? null : uploadButton}
        </Upload>
        <Modal
          visible={previewVisible}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </div>
    );
  }
}

export default Avatar;
